import { supabase, isSupabaseConfigured } from '../services/supabase';

export async function logAction(userRole: string | null, action: string, details: Record<string, any> = {}) {
  try {
    // 1. Get IP address (using a free public API for demo purposes, in production use Edge Function)
    let ipAddress = 'unknown';
    try {
      const res = await fetch('https://api.ipify.org?format=json');
      const data = await res.json();
      ipAddress = data.ip;
    } catch (e) {
      console.warn('Could not fetch IP address', e);
    }

    // 2. Get Device Info
    const deviceInfo = navigator.userAgent;

    const logEntry = {
      user_role: userRole || 'anonymous',
      action,
      details,
      ip_address: ipAddress,
      device_info: deviceInfo,
    };

    if (isSupabaseConfigured && supabase) {
      const { error } = await supabase
        .from('audit_logs')
        .insert([logEntry]);
        
      if (error) {
        console.error('Failed to save audit log to Supabase:', error);
      } else {
        console.log(`[Audit Log Saved] ${action} by ${userRole}`);
      }
    } else {
      // Mock logging if no Supabase
      import('../stores/adminStore').then(({ useAdminStore }) => {
        useAdminStore.getState().addLog({
          userRole: logEntry.user_role,
          action: logEntry.action,
          details: logEntry.details,
          ipAddress: logEntry.ip_address,
          deviceInfo: logEntry.device_info,
        });
      });
      console.log(`[Audit Log (Mock)]`, logEntry);
    }
  } catch (err) {
    console.error('Error in logAction:', err);
  }
}
